<template>
  <view class="texts">
    <view
      wx:for="{{tableValue}}"
      wx:key="index"
      class="text"
    >
      <view
        wx:for="{{item}}"
        wx:for-item="text"
        wx:for-index="idx" 
        wx:key="idx"
        class="column"
      >
        <view class="title">{{text.text}}</view>
        <view class="sub-text" wx:if="{{text.subText}}">{{text.subText}}</view>
      </view>
    </view>
  </view>
</template>

<script>
  import { createComponent } from '@didi/es-mpx-creator'

  createComponent({
    props: {
      tableValue: {
        type: Array,
        value: () => []
      }
    }
  })
</script>

<style lang="stylus" scoped>
.texts
  white-space pre-wrap
  margin 0 12px 12px
  font-size 14px
  line-height 1.3
  color #666
  font-family PingFangSC-Regular
  font-weight normal
  .text
    border-left 0.5px solid rgba(0, 0, 0, 0.08)
    border-right 0.5px solid rgba(0, 0, 0, 0.08)
    border-bottom 0.5px solid rgba(0, 0, 0, 0.08)
    display flex
    &:first-child
      border-top 0.5px solid rgba(0, 0, 0, 0.08)
      border-top-left-radius 8px
      border-top-right-radius 8px
      background rgba(231, 241, 255, 0.3)
      .title
        font-family PingFangSC-Medium
        margin-bottom 2px
      .sub-text
        font-size 12px
    &:last-child
      border-bottom-left-radius 8px
      border-bottom-right-radius 8px
    .column
      padding 10px
      flex 1
      border-right 0.5px solid rgba(0, 0, 0, 0.08)
</style>

<script name="json">
  module.exports = {
    component: true
  }
</script>